export const isFalse = (x) => x === false;
